module.exports = __webpack_public_path__ + "img/3.6b162a61.jpg";